import storeManager from '../store/StoreManager';
import apiActions from '../actions/ApiActions';

const connectionStatusService = {
    queue: [],
    processing: false,
    timeout: undefined,
    addStatusToQueue: (status = '', duration = -1, callback = () => {}) => {
        connectionStatusService.queue.push({ status, duration, callback });
        if (!connectionStatusService.processing) {
            connectionStatusService.startStatusQueue();
        }
    },

    forceStatus: (status = '', duration = -1, callback = () => {}) => {
        clearTimeout(connectionStatusService.timeout);
        connectionStatusService.timeout = undefined;
        connectionStatusService.queue.splice(0, connectionStatusService.queue.length, { status, duration, callback });
        connectionStatusService.processing = true;
        connectionStatusService.triggerNextStatusInQueue();
    },

    startStatusQueue: () => {
        connectionStatusService.processing = true;
        connectionStatusService.triggerNextStatusInQueue();
    },

    stopStatusQueueProcessing: () => {
        connectionStatusService.processing = false;
    },

    triggerNextStatusInQueue: () => {
        if (connectionStatusService.queue.length > 0) {
            // Remove current status from queue and trigger
            const { status, duration, callback } = connectionStatusService.queue.shift();
            connectionStatusService.triggerStatus(status);

            if (duration !== -1) {
                connectionStatusService.timeout = setTimeout(() => {
                    // When there is no queued status, set status to undefined
                    if (connectionStatusService.queue.length === 0) {
                        connectionStatusService.triggerStatus();
                    }
                    connectionStatusService.triggerNextStatusInQueue();
                    callback();
                }, duration);
            } else {
                connectionStatusService.triggerNextStatusInQueue();
                callback();
            }
        } else {
            // Empty queue, stop progress
            connectionStatusService.stopStatusQueueProcessing();
        }
    },

    triggerStatus: (status) => {
        storeManager.dispatch(apiActions.setApiConnectionStatus(status));
    },
};

export default connectionStatusService;
